import i18next, { changeLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  resources,
  supportedLanguages,
  Language,
  defaultLanguage,
} from '../locales';
import { logger } from './logger';
import { updatePreferredLanguageApi } from 'src/api';

const languageLocalStorageKey = 'userSettings.language';

export const i18n = {
  initiated: false,
  get language() {
    return i18next.language as Language;
  },
  init() {
    if (this.initiated) {
      logger.info('i18n already initiated');
      return;
    }

    i18next
      .use(initReactI18next)
      // for all options read: https://www.i18next.com/overview/configuration-options
      .init({
        resources,
        lng: localStorage.getItem(languageLocalStorageKey) || defaultLanguage,
        supportedLngs: supportedLanguages,
        fallbackLng: defaultLanguage,
        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        },
      });

    this.initiated = true;
  },
  changeLanguage(
    lng: Language,
    options: { persist?: boolean; syncBackend?: boolean } = {}
  ) {
    const { persist = false, syncBackend = false } = options;
    if (!this.initiated) {
      logger.error('i18n not initiated');
      return;
    }
    if (!supportedLanguages.includes(lng)) {
      logger.error(`i18n.changeLanguage: Unsupported language ${lng}`);
      return;
    }
    changeLanguage(lng);
    if (persist) {
      localStorage.setItem(languageLocalStorageKey, lng);
    }
    if (syncBackend) {
      updatePreferredLanguageApi({
        languageCode: lng,
      }).catch((error) => {
        logger.error('Failed to update user preferred language', error);
      });
    }
  },
};

export { defaultLanguage, supportedLanguages };
export type { Language };
